module.exports = __webpack_public_path__ + "assets/img/组 105@2x.88682002.png";